module.exports = __webpack_public_path__ + "img/to_do_four.79faa438.png";